import { Types } from "../../types";
import { all, call, put, takeLatest } from "redux-saga/effects";
import { getLatestCustomerCallsRequest } from "../apiRequests/dashboardRequest";
import { getCustomerLatestCallsErrorAction, getCustomerLatestCallsSuccessAction } from "../../actions/dashboardActions";
import { RecentCalls } from "../../interfaces/dashboard";






function* getLatestCallsRequestHandler() {
    try {

        const response: { data: any[] } = yield call(getLatestCustomerCallsRequest)
        let recentCalls = new RecentCalls()
        recentCalls.mapper(response.data)
        yield put(
            getCustomerLatestCallsSuccessAction(recentCalls.list)
        )

    } catch (error: any) {
        yield put(
            getCustomerLatestCallsErrorAction({
                error: error.message
            })
        )

    }
}



function* dashboardSaga() {
    yield all([takeLatest(Types.GET_LATEST_CALLS_REQUEST, getLatestCallsRequestHandler)]);



}

export default dashboardSaga